// @mui
import { Box, Button, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material';
// components
import { CenteredContent } from 'theme/elements/Content';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { FormButton } from 'theme/elements/Buttons';
import { Stack } from '@mui/system';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { CustomAppBar } from 'theme/layouts/navbar';

export default function PageNotFound() {
	const theme = useTheme();
	const navigate = useNavigate();
	const t = useAppSelector(selectTranslations);
	const imageUrl = useAppSelector(selectImageUrl);
	return (
		<Box sx={{ height: '100vh', background: theme.palette.root.graybg }}>
			<CustomAppBar open={false} mobile={true}>
				<img src={imageUrl('page.not_found.header.icon') || '/static_images/brand_logo_color.webp'} alt="open" />
			</CustomAppBar>
			<CenteredContent>
				<Stack spacing={5} sx={{ textAlign: 'center' }}>
					<Box
						sx={{
							position: 'relative',
							'&:before': {
								content: `"${t('error.code.404.title')}"`,
								fontSize: theme.typography.h2,
								top: 0,
								bottom: 0,
								right: 0,
								left: 0,
								position: 'absolute',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-around',
							},
							'& img': {
								[theme.breakpoints.down('sm')]: { width: '90%' },
							},
						}}
					>
						<img src={imageUrl('page.not_found.404.icon') || '/icons/404.svg'} />
					</Box>
					<Typography sx={{ fontFamily: theme.typography.body3 }}>
						{t('error.code.404.description')}
					</Typography>
					<FormButton>
						<Button
							variant="contained"
							onClick={() => {
								navigate(`/${pagesEnum.DASHBOARD}`);
							}}
						>
							{t('error.code.404.button')}
						</Button>
					</FormButton>
				</Stack>
			</CenteredContent>
		</Box>
	);
}
